module.exports = __webpack_public_path__ + "img/case-logo-26.5b38d002.png";